import { CpsSelectedDocument } from '@cs-cms/types';
import { createContext, useContext } from 'react';

interface IDocumentsContext {
  selectedDocuments: CpsSelectedDocument[];
  setSelectedDocuments?: (selectedDocuments: CpsSelectedDocument[]) => void;
  openDocument?: (contentType: string, documentId: string) => void;
  downloadFiles?: () => void;
  openDocumentLoading: boolean;
}

const defaultValue: IDocumentsContext = {
  selectedDocuments: [],
  openDocumentLoading: false
};

export const DocumentsContext = createContext<IDocumentsContext>(defaultValue);

export const useDocumentsContext = () => useContext(DocumentsContext);
